export const GIFTS = [
  { id: 'rose', name: 'Rose', emoji: '\u{1F339}', price: 1, animation: 'float' },
  { id: 'heart', name: 'Heart', emoji: '\u{2764}\u{FE0F}', price: 5, animation: 'float' },
  { id: 'fire', name: 'Fire', emoji: '\u{1F525}', price: 10, animation: 'burst' },
  { id: 'diamond', name: 'Diamond', emoji: '\u{1F48E}', price: 50, animation: 'confetti' },
  { id: 'crown', name: 'Crown', emoji: '\u{1F451}', price: 100, animation: 'confetti' },
  { id: 'rocket', name: 'Rocket', emoji: '\u{1F680}', price: 200, animation: 'confetti' },
];

export const STREAM_REACTIONS = ['\u{2764}\u{FE0F}', '\u{1F525}', '\u{1F44F}', '\u{1F60D}', '\u{1F389}', '\u{1F4AF}'];

export const STREAM_STATUS = {
  SETUP: 'setup',
  LIVE: 'live',
  ENDED: 'ended',
};

export const MAX_ACTIVE_REACTIONS = 30;
export const MAX_CHAT_MESSAGES = 200;
export const CHAT_DISPLAY_LIMIT = 30;
